import { useSelector } from 'react-redux'
import { BrandSectionView } from '../BrandSectionView'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import { instanceInfoSlice } from '@wellesley/instanceinfo'
import { getServerName } from 'helpers/getServerName'
import useFetchPlatformSettings from '@wellesley/settings/hooks/useFetchPlatformSettings'
import { brandingSettingsKeys } from '@wellesley/settings/keys'

import {
  DEFAULT_SERVER_VERSION,
  DEFAULT_IMAGE,
  DEFAULT_NAME,
  DEFAULT_COLOR,
} from './default_data'

export const BrandSection = ({ className }: { className?: string }) => {
  useFetchPlatformSettings(brandingSettingsKeys)
  const { selectBranding, selectAccess } = platformSettingsSlice.selectors

  const instanceInfo = useSelector(
    instanceInfoSlice.selectors.selectInstanceInfo,
  )
  const serverVersion = instanceInfo?.version
  const brandingSettings = useSelector(selectBranding)
  const { image, color, shortDescription, displayName } = brandingSettings || {}

  const { visibility } = useSelector(selectAccess) || {}

  const isPrivate = visibility === 'PRIVATE'

  return (
    <BrandSectionView
      isLoading={!brandingSettings}
      cover={image || DEFAULT_IMAGE}
      title={displayName || getServerName() || DEFAULT_NAME}
      color={color || DEFAULT_COLOR}
      serverVersion={serverVersion || DEFAULT_SERVER_VERSION}
      isPrivate={isPrivate}
      description={shortDescription}
      className={className}
    />
  )
}
